// extracted by mini-css-extract-plugin
export default {"talkUserListQR":"TaklUserListControlQRCode_talkUserListQR__2xL4h"};